import * as React from 'react';
import { BaseComponentProps, BaseComponentState, BaseComponent } from '../base/BaseComponent';
import { MasterData } from '../shared/MasterData';
import { isNull, getContentFronStorage } from '../utils/index';

export interface CurrencyListProps extends BaseComponentProps {
	lang: string;
	currency: string;
	currencyChange: (cur: string) => any;
	// CurrencyList: MasterData.Currency[];
	changeCurrency: boolean;
}

export interface CurrencyListState extends BaseComponentState {
	listCurrency: any[];
	currency: string;
	CurrencyList: MasterData.Currency[];
	requesting: boolean;
}

export class CurrencyList extends BaseComponent<CurrencyListProps, CurrencyListState> {

	constructor(props: CurrencyListProps) {
		super(props);
		this.state = {
			currency: props.currency,
			listCurrency: [],
			CurrencyList: [],
			requesting: true
		};
	}

	componentDidMount() {
		this.getData();
	}

	getData = () => {
		getContentFronStorage(this.props.lang, "Currency").then(
			(d: any[]) => {
				// this.setState({ data: d });
				this.setState({
					CurrencyList: d.map(d1 => {
						return { code: d1.id as string, description: d1.description };
					}), requesting: false
				});
			}).catch((exc) => { console.error('error: ', exc); });
	}

	renderCurrencyList: () => JSX.Element[] = () => {
		let ret: JSX.Element[] = [];
		// let langNot: string = '';
		if (!isNull(this.state.CurrencyList)) {
			for (let x of this.state.CurrencyList) {
				let className: string = '';
				let xCode: string = x.code as string;
				if (xCode === this.props.currency) {
					className = 'active';
					// langNot = x.description;
				}

				ret.push(
					<li className={className} key={xCode}>
						<a
							onClick={() => {
								this.props.currencyChange(xCode);
							}}
						> {x.code} - {x.description}
						</a>
					</li>
				);
			}
		}

		return ret;

	}
	render() {
		if ( this.state.haveReactError ) {
            return this.renderErrorPanel() ; 
        } 
		let langNot: string | any = '';
		if (!isNull(this.state.CurrencyList)) {
			for (let x of this.state.CurrencyList) {
				let xCode: string = x.code as string;
				if (xCode === this.props.currency) {
					langNot = x.description;
				}
			}
		}
		let classCur = '';
		if (this.props.changeCurrency === false) {
			classCur = 'hide';
		}
		return (
			<li id="currencyCode" className={classCur}>
				<a data-toggle="dropdown" href="#" className="dropdown-toggle show-on-mobile"> {this.props.currency} - {langNot} </a>
				<a data-toggle="dropdown" href="#" className="dropdown-toggle show-on-desktop"> {this.props.currency} </a>
				<ul className="dropdown-menu" >
					{this.renderCurrencyList()}
				</ul>
			</li>
		);

	}

}


// WEBPACK FOOTER //
// ./src/header/CurrencyList.tsx